import { render } from "./ServiceMenu.vue?vue&type=template&id=930fe51a"
import script from "./ServiceMenu.vue?vue&type=script&lang=js"
export * from "./ServiceMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__